"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _constants = require("../../utils/constants");

var _constants2 = _interopRequireDefault(_constants);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FlowController = function () {
  function FlowController(MermaidService, $scope) {
    'ngInject';

    (0, _classCallCheck3.default)(this, FlowController);
    this.mermaidService = MermaidService;
    this.$scope = $scope;
  }

  (0, _createClass3.default)(FlowController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;

      this.mermaidService.init();

      this.treeViewOptions = {
        dataSource: [{
          text: "Flow Diagrams",
          expanded: true,
          items: [{
            text: "Bot",
            expanded: true,
            items: [
            // { id: c.flowDiagrams.SMS_CHANNEL, text: "SMS Channel" },
            { id: _constants2.default.flowDiagrams.FACEBOOK_CHANNEL, text: "Helper Flow v1.1", selected: true }, { id: _constants2.default.flowDiagrams.LOCATE_HELPERS_IN_AREA_FLOW, text: "Locate Helpers In Area Flow" }, { id: _constants2.default.flowDiagrams.POST_JOB_FLOW, text: "Post Job Flow" }, { id: _constants2.default.flowDiagrams.DISPLAY_PROFILE_FLOW, text: "Display Profile Flow" }]
          }, {
            text: "Jobs",
            items: [{ id: _constants2.default.flowDiagrams.BABYSITTING_JOB, text: "Babysitting Job" }, { id: _constants2.default.flowDiagrams.RECURRING_JOB, text: "Recurring Job" }]
          }]
        }],
        select: function select(e) {
          return _this.onTreeViewSelect(e);
        }
      };

      this.renderGraph(_constants2.default.flowDiagrams.FACEBOOK_CHANNEL);
    }
  }, {
    key: "onTreeViewSelect",
    value: function onTreeViewSelect(e) {
      var treeview = $("#flow-tree-view").data("kendoTreeView");
      var dataItem = treeview.dataItem(e.node);

      if (dataItem.id) this.renderGraph(dataItem.id);
    }
  }, {
    key: "renderGraph",
    value: function renderGraph(id) {
      this.setHeader(id);
      var graphData = this.mermaidService.getGraph(id);

      this.mermaidService.render("graph-" + id, graphData, function (svg, bindingFunctions) {
        document.getElementById("graph").innerHTML = svg;
      });
    }
  }, {
    key: "setHeader",
    value: function setHeader(id) {
      var _this2 = this;

      var header = "";
      switch (id) {
        case _constants2.default.flowDiagrams.LOCATE_HELPERS_IN_AREA_FLOW:
          header = "Locate Helpers in Area Flow";
          break;
        case _constants2.default.flowDiagrams.POST_JOB_FLOW:
          header = "Post Job Flow";
          break;
        case _constants2.default.flowDiagrams.DISPLAY_PROFILE_FLOW:
          header = "Display Profile Flow";
          break;
        case _constants2.default.flowDiagrams.BABYSITTING_JOB:
          header = "Babysitting Job";
          break;
        case _constants2.default.flowDiagrams.RECURRING_JOB:
          header = "Recurring Job";
          break;
        case _constants2.default.flowDiagrams.FACEBOOK_CHANNEL:
          header = "Helper Flow v1.1";
          break;
      }

      setTimeout(function () {
        _this2.header = header;
        _this2.$scope.$apply();
      }, 0);
    }
  }]);
  return FlowController;
}();

exports.default = FlowController;


/** WEBPACK FOOTER **
 ** ./client/app/containers/flow/flow.controller.js
 **/